import { FoodsIcon } from "@foodpilot/foods";
import { Button, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { URLHandler } from "src/services/URLHandler";

type SeeQuestionnaireButtonProps = {
    metaForUrl: {
        companyId: number;
        ssqId: number;
        campaignId: number;
        scoreId: string;
    };
    isComplete: boolean;
};
export const SecondaryButton = (props: SeeQuestionnaireButtonProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const {
        metaForUrl: { companyId, ssqId, campaignId, scoreId },
        isComplete,
    } = props;

    if (isComplete) {
        const to = URLHandler.company.questionnaireScore(companyId, ssqId, campaignId, scoreId);
        return (
            <Link to={to}>
                <Button
                    variant="secondary"
                    startIcon={<FoodsIcon size={2} icon={"questionnaires"} />}
                    sx={(theme) => ({
                        width: "100%",
                        ...theme.typography["big-medium"],
                    })}
                >
                    {t("company.dashboard.go_to_questionnaire", "See questionnaire")}
                </Button>
            </Link>
        );
    }

    const to = URLHandler.company.ssqScore(companyId, ssqId, campaignId, Number(scoreId));
    return (
        <Link to={to}>
            <Button
                variant="secondary"
                startIcon={<FoodsIcon size={2} icon={"analyzeData"} />}
                sx={{ width: "100%", ...theme.typography["big-medium"] }}
            >
                {t("company.dashboard.go_to_details", `See details`)}
            </Button>
        </Link>
    );
};
